/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { RadioGroupItem } from "@radix-ui/react-radio-group";

import { spacing } from "../../../../../global/emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { RadioButtonIcon } from "../../../_base/icons/Icon/GeneralIcons";

const inputStyle: Interpolation = {
  display: "none",
};
const labelStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: spacing.xs,
  justifyContent: "flex-start",
};

type RadioInputProps<T extends string = string> = {
  value: T;
  label: string;
  isSelected: boolean;
  onChange: (isChecked: boolean) => void;
  name: string;
};

export const RadioInput = <T extends string = string>({
  value,
  name,
  label,
  isSelected,
  onChange,
}: RadioInputProps<T>) => (
  <RadioGroupItem value={value} asChild>
    <label key={value} htmlFor={value} css={labelStyle} tabIndex={0}>
      {isSelected ? <RadioButtonIcon.On /> : <RadioButtonIcon.Off />}
      <Text type="body" size="l">
        {label}
      </Text>
      <input
        type={"radio"}
        name={name}
        id={value}
        value={value}
        css={inputStyle}
        checked={isSelected}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
    </label>
  </RadioGroupItem>
);
